<template>
    <article class="ctype_1" itemscope itemtype="http://schema.org/Article">
        <div v-if="img" class="article-header">
            <img loading="lazy" :src="img" itemprop="image" class="article-img transition" :alt="title" />
        </div>
        <h2 itemprop="title" class="article-title">{{ title }}</h2>
        <div class="article-text" itemprop="articleBody description" v-html="text"></div>
    </article>
</template>

<script>
export default {
    name: 'Article',
    props: {
        title: String,
        text: String,
        img: String,
    },
};
</script>

<style>
.article-img,
.article-video,
.article-media_inline,
.article-embed {
    display: block;
    width: 100%;
    overflow: hidden;
    position: relative;
    margin-bottom: 1.5rem;
    border-radius: 0.8rem;
}

.article-img_responsive {
    height: 0;
}

.article-video {
    height: 0;
    padding-bottom: 56.25%;
    background-color: #ccc;
}

.article-video .button {
    position: absolute;
    left: 1rem;
    bottom: 1rem;
    z-index: 5;
}

.article-media_inline {
    height: 0;
    padding-bottom: 56.25%;
}

.article-media_inline.article-media_audio {
    height: 5.5rem;
    padding: 0;
}

.article-media_inline iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}

.article-text {
    margin-bottom: 1.5rem;
}

.article-text p {
    margin: 0;
}

.article-text ol,
.article-text ul {
    list-style: disc inside;
    margin-bottom: 2rem;
}

.article-text a {
    text-decoration: underline;
    color: var(--color-accent-dark);
}

@media (max-width: 33.9em) {
    .article-img {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
        float: none;
    }
}
</style>
